module.exports = __webpack_public_path__ + "img/teamwear.bc478493.jpg";